import { render, staticRenderFns } from "./ScanFyEdit.vue?vue&type=template&id=023185cb&scoped=true"
import script from "./ScanFyEdit.vue?vue&type=script&lang=js"
export * from "./ScanFyEdit.vue?vue&type=script&lang=js"
import style0 from "./ScanFyEdit.vue?vue&type=style&index=0&id=023185cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023185cb",
  null
  
)

export default component.exports